import React, { Component } from "react";
import { Button } from "antd";

import "antd/lib/button/style";

/**
 * 按钮权限
 *
 * @export
 * @interface VhButtonPermission
 */
export interface VhButtonPermission {
  /**
   * id
   *
   * @type {number}
   * @memberof VhButtonPermission
   */
  id: number;
  /**
   * 权限code
   *
   * @type {string}
   * @memberof VhButtonPermission
   */
  code: string;
  /**
   * 权限名称
   *
   * @type {string}
   * @memberof VhButtonPermission
   */
  name: string;
}

/**
 * 按钮属性
 *
 * @export
 * @interface VhButtonProps
 */
export interface VhButtonProps {
  /**
   * 权限code
   *
   * @type {string}
   * @memberof VhButtonProps
   */
  code: string;
  /**
   * 权限列表
   *
   * @type {VhButtonPermission[]}
   * @memberof VhButtonProps
   */
  permissionList: VhButtonPermission[];
  // 其他属性
  [key: string]: any;
}

/**
 * 按钮封装
 *
 * @class VhButton
 * @extends {Component}
 */
class VhButton extends Component<VhButtonProps> {
  public render() {
    const props = {...this.props};
    const isOk = this.props.permissionList.find((item: VhButtonPermission) => item.code === this.props.code);
    delete props.permissionList;
    delete props.code;

    return isOk ? <Button {...props} /> : null;
  }
}

export default VhButton;
